import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-delete-confirmation-dialog',
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrls: ['./delete-confirmation-dialog.component.scss'],
})
export class DeleteConfirmationDialogComponent {
    @Input() title: string;
    @Input() description: string;
    @Input() inputLabel: string;
    @Input() confirmationText: string;
    enteredText: string = '';

    constructor(private activeModal: NgbActiveModal) {}

    dismiss(): void {
        this.activeModal.dismiss();
    }

    submit(): void {
        this.activeModal.close('confirmed');
    }
}
